import React, { useEffect, useState } from 'react';

import { Table } from '../../../../common/table/Table';
import Modal from '../../../../common/modal/Modal';
import { VisitPackCreation } from '../VisitPackCreation';
import { AvailableFormsSearch } from './AvaliableFormsSearch';

export const VisitPackSearch = ({
  setShowFormsForVisit,
  visits,
  setVisits,
  forms,
  visit,
  setVisit,
  setSpinnerText,
  context,
  showToaster,
  edit,
  setVisitCodeEdited,
  study,
  enrolmentVisitAllowed = true,
  scheduleHasParticipantsLinked = false,
}) => {
  const [searchResults, setSearchResults] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showAvailableForms, setShowAvailableForms] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [modalHeader, setModalHeader] = useState('');

  useEffect(() => {
    if (edit) {
      setShowFormsForVisit(true);
    }

    const updatedVisits = visits.map((visit) => {
      if (visit && visit.formExternalReferences && visit.formExternalReferences.length > 0) {
        const noOfForms = visit.formExternalReferences.length;
        return { ...visit, noOfForms };
      }

      return visit;
    });

    setSearchResults(updatedVisits);
  }, [setShowFormsForVisit, visits, edit]);

  const handleAddButtonClick = () => {
    if (scheduleHasParticipantsLinked) return;

    setShowAvailableForms(false);
    setVisit(null);
    setEditMode(true);
    setModalHeader('Add Visit');
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleVisitPackRowClick = (visit) => {
    setVisit(visit);
    setShowAvailableForms(true);
    setIsModalOpen(true);
  };

  const handleViewVisitFormsClick = (visitToViewForms) => {
    setShowFormsForVisit(true);
    setVisit(visitToViewForms);
  };

  const handleEditVisitClick = (visit) => {
    setVisit(visit);
    setEditMode(true);
    setModalHeader('Edit Visit');
    setShowAvailableForms(false);
    setIsModalOpen(true);
  };

  const deleteVisit = (visit) => {
    if (scheduleHasParticipantsLinked) return;

    const copyOfVisits = [...visits];

    const filteredVisits = copyOfVisits.filter((visitInState) => {
      if (
        visit.visitCode === visitInState.visitCode &&
        visit.visitType === visitInState.visitType &&
        visit.day === visitInState.day &&
        visit.windowBefore === visitInState.windowBefore &&
        visit.windowAfter === visitInState.windowAfter
      ) {
        return false;
      }

      return true;
    });

    setVisits(filteredVisits);
  };

  return (
    <div className="problem-search-results-container">
      <div className="problem-search-results-container">
        {searchResults && (
          <>
            <Table
              tableData={searchResults}
              hiddenColumns={[
                'externalReference',
                'windowBefore',
                'windowAfter',
                'longVisit',
                'forms',
                'hasVisits',
                'formExternalReferences',
                'availableForms',
                'enrolmentVisit',
                'visitCodeToUpdate',
                'visitCodeEdited',
              ]}
              searchEnabled={true}
              filterEnabled={false}
              onRowClick={handleVisitPackRowClick}
              tableTitle="Visit Packs"
              buttonText={!scheduleHasParticipantsLinked ? 'Add' : undefined}
              onButtonClick={handleAddButtonClick}
              buttonDisabled={false}
              maxRowCount={4}
              actionColumnEnabled={true}
              actionOneClick={handleEditVisitClick}
              actionTwoClick={handleViewVisitFormsClick}
              horizontalScroll
            />

            {isModalOpen && !showAvailableForms && (
              <Modal
                closeModal={closeModal}
                setIsModalOpen={setIsModalOpen}
                headerTitle={modalHeader}
                hideButton={true}
                width="1300px"
                justifyContent="center"
                contentPadding="2px"
              >
                <VisitPackCreation
                  numberOfVisits={1}
                  setNumberOfVisits={() => undefined}
                  visit={visit}
                  editMode={editMode}
                  closeModal={closeModal}
                  setVisitsToReturn={setVisits}
                  setVisitCodeEdited={setVisitCodeEdited}
                  pageSize={10}
                  deleteVisit={deleteVisit}
                  canEditSchedule={scheduleHasParticipantsLinked}
                  study={study}
                  enrolmentVisitSet={visits.some((visit) => visit.enrolmentVisit)}
                  enrolmentVisitAllowed={enrolmentVisitAllowed}
                  scheduleHasParticipantsLinked={scheduleHasParticipantsLinked}
                  existingVisitsForValidation={visits}
                />
              </Modal>
            )}

            {isModalOpen && showAvailableForms && (
              <Modal
                closeModal={closeModal}
                setIsModalOpen={setIsModalOpen}
                headerTitle="Create Visit Pack"
                hideButton={true}
                width="55%"
                justifyContent="center"
                contentPadding="10px"
              >
                <AvailableFormsSearch
                  visit={visit}
                  forms={forms}
                  setVisits={setVisits}
                  visits={visits}
                  setVisit={setVisit}
                  closeModal={closeModal}
                  editMode={edit}
                  setSpinnerText={setSpinnerText}
                  showToaster={showToaster}
                  context={context}
                />
              </Modal>
            )}
          </>
        )}
      </div>
    </div>
  );
};
